import React from "react";
import Banner from "../Components/Banner/Banner";
import Cointable from "../Components/Banner/Cointable";

const Homepage = () => {
  return (
    <div>
      {" "}
      <Banner /> <Cointable />
    </div>
  );
};

export default Homepage;
